import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pushPageView } from "./analytics";

// Rutas cuyo último segmento es una credencial (link del informe de anuncios): nunca viajan a GA.
const TOKEN_ROUTE = /^\/informe\/[^/]+/;

/** Path que se manda a analytics: sin el token de los links públicos. */
export function analyticsPath(location) {
  if (TOKEN_ROUTE.test(location.pathname)) return '/informe/[token]';
  return location.pathname + location.search + location.hash;
}

/**
 * Componente invisible que reporta page views al cambiar de ruta (GA4).
 * Ver src/analytics/analytics.js para documentación completa.
 */
export default function AnalyticsPageView() {
  const location = useLocation();

  useEffect(() => {
    pushPageView(analyticsPath(location));
  }, [location]);

  return null;
}
